import React, { useState } from "react";
import ViewItems from "../../../components/ViewItems";
import Text from "../../../components/Text";
import { fontSizes } from "../../../constants/constants";
import dynamicfunction from "../../../utils/dynamicfunction";
import ViewReverse from "../../../components/ViewReverse";
import { ReactSVG } from "react-svg";
import { cn, formatNumbers } from "../../../utils/utils";
import SarSymbol from "../../../components/SarSymbol";

const CardView = ({ title, icon, amount, secure = false, isSecure, setIsSecure, isSymbol = true, digits = 2 }) => {
  const { TextWeight } = dynamicfunction();

  return (
    <ViewItems
      className={"border border-grey shadow rounded-xl px-4 py-5 w-full"}
    >
      <Text text={title} size={fontSizes.h16} weight={TextWeight.semiBold} />

      <ViewReverse className={"items-center mt-4"} isReverse={false}>
        <ViewReverse>
          {isSymbol &&
            <SarSymbol size={fontSizes.h26} />
          }
          <Text
            text={secure && isSecure ? "********" : formatNumbers(amount, digits)}
            size={fontSizes.h26}
            weight={TextWeight.medium}
          />
        </ViewReverse>
        <ReactSVG
          src={icon}
          className={cn(secure && setIsSecure && "cursor-pointer", "mx-4")}
          onClick={() => secure && setIsSecure && setIsSecure(!isSecure)}
        />
      </ViewReverse>
    </ViewItems>
  );
};

export default CardView;
